import ENV_VARS from '@/config'
import { post, put, del, get } from '@/ports/api'
const { BACKEND_SERVER } = ENV_VARS

export const getApplication = get(`${BACKEND_SERVER}/applications/%applicationId%`, {
  failSilently: true
})
export const getApplicationNoLoading = get(`${BACKEND_SERVER}/applications/%applicationId%`, {
  failSilently: true,
  noLoading: true
})

export const createApplication = post(`${BACKEND_SERVER}/applications/listings/%listingId%`)
export const favouriteApplication = put(
  `${BACKEND_SERVER}/applications/%applicationId%/favourite`,
  {
    noLoading: true
  }
)
export const unfavouriteApplication = del(
  `${BACKEND_SERVER}/applications/%applicationId%/favourite`,
  {
    noLoading: true
  }
)
export const deleteApplication = del(`${BACKEND_SERVER}/applications/%applicationId%`)
export const addExternal = post(`${BACKEND_SERVER}/applications/add_external`)
export const addExternalRenewal = post(
  `${BACKEND_SERVER}/applications/contract_renewal/add_external`
)

export const getApplications = get(
  `${BACKEND_SERVER}/users/bootstrap/listings/%listingId%/applications`
)

export const copyApplication = post(`${BACKEND_SERVER}/applications/%applicationId%/duplicate`)

export const updateTrustScoreFlags = put(
  `${BACKEND_SERVER}/applications/%applicationId%/trustscore_flags`
)

export const getApplicationTrustScore = get(
  `${BACKEND_SERVER}/trust_score/applications/%applicationId%`,
  {
    noLoading: true
  }
)
export const viewApplication = put(`${BACKEND_SERVER}/applications/%applicationId%/view`, {
  noLoading: true
})

export const getStandAloneTrustScoreInfo = get(
  `${BACKEND_SERVER}/trust_score/standalone/%trustScoreId%`
)
export const saveStandAloneTrustScore = post(`${BACKEND_SERVER}/trust_score/standalone`)
export const updateStandAloneTrustScore = put(
  `${BACKEND_SERVER}/trust_score/standalone/%trustScoreId%`
)
export const uploadTenantConsent = post(
  `${BACKEND_SERVER}/trust_score/standalone/%trustScoreId%/consent`,
  { noLoading: true }
)
export const deleteTenantConsent = del(
  `${BACKEND_SERVER}/trust_score/standalone/%trustScoreId%/consent`
)

export const unlockStandAloneTrustScore = post(
  `${BACKEND_SERVER}/trust_score/standalone/%trustScoreId%/run`
)

export const getApplicationList = post(`${BACKEND_SERVER}/trust_score/standalone/search`)

export const retrieveLookupCountForTrustScore = get(
  `${BACKEND_SERVER}/trust_score/standalone/address_count`,
  {
    noLoading: true
  }
)
